import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getToken, setToken, UNAUTHORIZED_EVENT } from '../api/client'
import { AuthContext } from './context'

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setLocal] = useState<string | null>(getToken())
  const queryClient = useQueryClient()

  const logout = useCallback(() => {
    setToken(null)
    setLocal(null)
    queryClient.clear()
  }, [queryClient])

  const login = useCallback((t: string) => {
    setToken(t)
    setLocal(t)
  }, [])

  // The API client clears the token on any 401; mirror that into React state so routes redirect to sign-in.
  useEffect(() => {
    const onUnauthorized = () => setLocal(null)
    window.addEventListener(UNAUTHORIZED_EVENT, onUnauthorized)
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, onUnauthorized)
  }, [])

  const value = useMemo(() => ({ authed: token !== null, login, logout }), [token, login, logout])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
